import https from "./http.js";
import axios from "axios";
export default {
  // ----------------公共接口--------------------------

  //  获取省市县
  getAreaTree: function (isNoLoad) {
    return https.get({ url: "/area/list", loading: isNoLoad ? false : true });
  },

  // 字典值
  getDictDetail: function (params, isNoLoad) {
    return https.get({
      url: "/base/api/sys/dict/detail/detail",
      params: params,
      loading: isNoLoad ? false : true,
    });
  },

  // 字典值列表
  getDictList: function (params) {
    return https.post({
      url: "/base/api/sys/dict/list",
      params: params,
    });
  },

  // 添加大类
  addDict: function (params) {
    return https.post({
      url: "/base/api/sys/dict/add",
      params: params,
    });
  },

  // 字典值 添加子类
  addDictDetail: function (params) {
    return https.post({
      url: "/base/api/sys/dict/detail/add",
      params: params,
    });
  },

  // 上传文件
  uploadFile: function (params) {
    return https.post({
      url: "/image/upload",
      params: params,
      contentType: "multipart/form-data;",
    });
  },

  /* -----------------------------------登录 ------------------------------*/
  // 验证码
  getImgVerification: function (uuid) {
    return https.get({
      url: "/captcha/create",
      loading: false,
    });
  },

  // 登录获取token
  oauthToken: function (params) {
    return https.post({
      url: "/user/login",
      params: params,
      other: {
        headers: {
          // "Content-Type": "application/x-www-form-urlencoded"
        },
        auth: {
          username: "c8c0a918-16b7-45a8-93a5-7ace9a10568c",
          password:
            "$2a$10$XKGi5cUZuLgBUg1x9GzfvesNeybPjDSBE5tChXZlRxG3v6h3rkKK6",
        },
      },
    });
  },

  // 获取按钮权限
  getBtnPermission() {
    return https.get({
      url: "/role/authority",
      loading: false,
    });
  },

  /*---------------------------------------一张图 -------------------------------*/

  // 地图服务？？
  getMapServiceList: function (params) {
    return https.post({
      url: "/auto/api/map/service/list",
      params: params,
    });
  },

  // 一张图顶部数量统计
  getMapTopStatistics: function (params) {
    return https.get({
      url: "/screen/number",
      loading: false,
    });
  },

  // 查询地图站、设备、传感器数据
  mapData: function (params) {
    return https.get({
      url: "/screen/map",
      params: params,
      loading: false,
    });
  },

  // 站统计数据
  getMapStationStatistics: function (params) {
    return https.get({
      url: "/screen/station",
      params: params,
      loading: false,
    });
  },

  // 设备统计数据
  getMapDeviceStatistics: function (params) {
    return https.get({
      url: "/screen/device",
      params: params,
      loading: false,
    });
  },

  //  传感器统计数据
  getMapSensorStatistics: function (params) {
    return https.get({
      url: "/screen/sensor",
      params: params,
      loading: false,
    });
  },
  /*----------------------------------------站网管理-------------------------------------*/
  // 站点列表
  getStationManageList: function (params, isNoLoad) {
    return https.get({
      url: "/station/list",
      params: params,
      loading: isNoLoad ? false : true,
    });
  },
  // 详情
  getStationInfo: function (params, isNoLoad) {
    return https.get({
      url: `/station/${params.id}`,
      loading: false,
    });
  },

  // 新增
  createStation: function (params) {
    return https.post({
      url: "/station/create",
      params: params,
    });
  },
  // 更新
  updateStation: function (params) {
    return https.post({
      url: "/station/edit",
      params: params,
    });
  },
  // 删除
  delStation: function (params) {
    return https.post({
      url: "/station/remove",
      params: params,
    });
  },
  //导出
  exportStation: function (params) {
    return https.post({
      url: "/station/export",
      params: params,
      other: {
        responseType: "blob",
        contentType: "application/octet-stream;charset:utf-8",
      },
    });
  },

  // 获取所有站名称
  getStationNames: function () {
    return https.get({ url: "/station/names" });
  },

  /**-------------------------------设备管理------------------------------*/
  /* 监测设备管理 */
  // 设备列表
  getMonitorDeviceManageList: function (params, isNoLoad) {
    return https.get({
      url: "/device/list",
      params: params,
      loading: isNoLoad ? false : true,
    });
  },

  // 查询设备关联工单
  getDeviceByRepair(params) {
    return https.get({
      url: "/mobile/device/all",
      params,
    });
  },

  // 获取设备名称
  getDeviceNames: function (params) {
    return https.get({
      url: "/device/names",
      params,
      loading: false,
    });
  },

  // 通过站找设备
  getDeviceByStationId: function (params) {
    return https.get({
      url: `/device/list`,
      params,
    });
  },

  // 新增
  createDevice: function (params) {
    return https.post({
      url: "/device/create",
      params,
    });
  },

  editMonitorDevice: function (params) {
    return https.post({
      url: "/device/edit",
      params: params,
    });
  },

  // 详情
  getMonitorDeviceInfo: function (params, isNoLoad) {
    return https.get({
      url: `device/${params.id}`,
      loading: isNoLoad ? false : true,
    });
  },

  // 删除
  delMonitorDevice: function (params) {
    return https.post({
      url: "/device/remove",
      params: params,
    });
  },

  // 智能井锁
  downLock: function (params) {
    return https.post({
      url: "/mqtt/lock",
      params: params,
    });
  },

  // 远程配置
  downConfig: function (params) {
    return https.post({
      url: "/mqtt/config",
      params: params,
    });
  },

  // 读取配置
  readConfig: function (params) {
    return https.post({
      url: "/mqtt/configuration",
      params: params,
    });
  },

  // 读取mode
  readMode: function (params) {
    return https.post({
      url: "/mqtt/rep/get-mode",
      params: params,
    });
  },

  // 设置mode
  setMode: function (params) {
    return https.post({
      url: "/mqtt/rep/set-mode",
      params: params,
    });
  },

  readGnssMode: function (params) {
    return https.post({
      url: "/mqtt/gnss/get-mode",
      params: params,
    });
  },

  // 设置mode
  setGnssMode: function (params) {
    return https.post({
      url: "/mqtt/gnss/set-mode",
      params: params,
    });
  },

  // 时间读取
  readTime: function (params) {
    return https.post({
      url: "/mqtt/rep/get-time",
      params: params,
    });
  },

  readGnssTime: function (params) {
    return https.post({
      url: "/mqtt/gnss/get-time",
      params,
    });
  },

  setGnssTime: function (params) {
    return https.post({
      url: "/mqtt/gnss/set-time",
      params: params,
    });
  },

  // 时间设置
  setTime: function (params) {
    return https.post({
      url: "/mqtt/rep/set-time",
      params: params,
    });
  },

  // 时间读取
  readAttr: function (params) {
    return https.post({
      url: "/mqtt/rep/get-attr",
      params: params,
    });
  },

  // 加报读取
  readGnssAttr: function (params) {
    return https.post({
      url: "/mqtt/gnss/get-attr",
      params: params,
    });
  },

  setAttr: function (params) {
    return https.post({
      url: "/mqtt/rep/set-attr",
      params: params,
    });
  },

  setGnssAttr: function (params) {
    return https.post({
      url: "/mqtt/gnss/set-attr",
      params: params,
    });
  },

  // 读取设备信息
  readInfo: function (params) {
    return https.post({
      url: "/mqtt/info",
      params,
    });
  },

  readRepInfo: function (params) {
    return https.post({
      url: "/mqtt/rep/status",
      params,
    });
  },

  // 远程校准
  downCheck: function (params) {
    return https.post({
      url: "/mqtt/calibrate",
      params: params,
    });
  },

  downRepCheck: function (params) {
    return https.post({
      url: "/mqtt/rep/calibration",
      params: params,
    });
  },

  // 实时读数
  downRead: function (params) {
    return https.post({
      url: "/mqtt/realtime",
      params: params,
    });
  },

  //
  downRepRead: function (params) {
    return https.post({
      url: "/mqtt/rep/realtime",
      params,
    });
  },

  // 历史数据
  readHistory: function (params) {
    return https.post({
      url: "/mqtt/history",
      params: params,
    });
  },

  getCrack: function (params) {
    return https.post({
      url: "/mqtt/crack/get",
      params: params,
    });
  },

  setCrack: function (params) {
    return https.post({
      url: "/mqtt/crack/set",
      params: params,
    });
  },

  getRepMqtt: function (params) {
    return https.post({
      url: "/mqtt/rep/get-mqtt",
      params: params,
    });
  },

  readGnssLink: function (params) {
    return https.post({
      url: "/mqtt/gnss/switch",
      params: params,
    });
  },
  setGnssLink: function (params) {
    return https.post({
      url: "/mqtt/gnss/set-switch",
      params: params,
    });
  },
  getGnssTcp: function (params) {
    return https.post({
      url: "/mqtt/gnss/get-tcp",
      params: params,
    });
  },
  setGnssTcp: function (params) {
    return https.post({
      url: "/mqtt/gnss/set-tcp",
      params: params,
    });
  },
  getGnssMqtt: function (params) {
    return https.post({
      url: "/mqtt/gnss/get-mqtt",
      params: params,
    });
  },
  setGnssMqtt: function (params) {
    return https.post({
      url: "/mqtt/gnss/set-mqtt",
      params: params,
    });
  },
  // 下发指令
  // downCommand: function (params) {
  //   return https.post({
  //     url: "/mqtt/lock",
  //     params: params,
  //   });
  // },

  //下发指令历史
  getDownOriginalReportList: function (params) {
    return https.get({
      url: "/data/history/device",
      params: params,
    });
  },

  // 下发报警
  downAlarm: function (params) {
    return https.post({
      url: "/mqtt/alarm",
      params: params,
    });
  },

  // 设置累计雨量
  downRain: function (params) {
    return https.post({
      url: "/mqtt/rain",
      params: params,
    });
  },

  // 重启设备
  resetDevice: function (params) {
    return https.post({
      url: "/mqtt/reset",
      params,
    });
  },

  resetRepDevice: function (params) {
    return https.post({
      url: "/mqtt/rep/restart",
      params,
    });
  },

  // 恢复出厂设置
  recoverData: function (params) {
    return https.post({
      url: "/mqtt/recover",
      params,
    });
  },

  // 清空数据
  clearData: function (params) {
    return https.post({
      url: "/mqtt/clear",
      params,
    });
  },
  responseCommand(params) {
    return https.get({ url: "/mqtt/response", params });
  },

  responseHistory(params) {
    return https.get({ url: "/mqtt/history/response", params });
  },

  // 读取响应
  responseRepCommand(params) {
    return https.get({ url: "/mqtt/rep/response", params });
  },

  // 读取
  getMqtt(params) {
    return https.get({
      url: "/mqtt/event",
      params,
    });
  },

  // 根据站点Id查询设备列表??????????????????????????
  getMonitorDeviceInfoList: function (params) {
    return https.get({ url: `device/${params.id}` });
  },

  //导出
  exportDevice: function (params) {
    return https.post({
      url: "/device/export",
      params,
      other: {
        responseType: "blob",
        contentType: "application/octet-stream;charset:utf-8",
      },
    });
  },

  setKeep: function (params) {
    return https.post({
      url: "/device/keep",
      params,
    });
  },

  // 设备部分信息
  // selectDeviceSub: function (params) {
  //   return https.post({
  //     url: "/base-data/api/device/data",
  //     params: params,
  //   });
  // },

  /* 传感器管理 */
  // 传感器列表
  getSensorManageList: function (params, isNoLoad) {
    return https.get({
      url: "/sensor/list",
      params: params,
      loading: isNoLoad ? false : true,
    });
  },
  getSensorNames: function (params) {
    return https.get({
      url: "/sensor/names",
      params: params,
      loading: false,
    });
  },
  // 根据设备id查询传感器
  getSensorByDeviceId: function (params) {
    return https.get({
      url: "/sensor/belongs",
      params,
    });
  },
  // 根据传感器id获取解析数据
  getParseByDeviceId: function (params) {
    return https.get({
      url: "/data/chart",
      params,
    });
  },

  // 设备状态
  getDeviceState(params) {
    return https.get({
      url: "/data/state",
      params,
    });
  },

  // 图表
  getDeviceChart: function (params) {
    return https.get({
      url: "/data/chart",
      params,
    });
  },
  // 详情
  getSensorInfo: function (params, isNoLoad) {
    return https.get({
      url: `/sensor/${params.id}`,
      // loading: isNoLoad ? false : true,
    });
  },
  // 新增
  createSensor: function (params) {
    return https.post({
      url: "/sensor/create",
      params: params,
    });
  },
  // 修改
  updateSensor: function (params) {
    return https.post({
      url: "/sensor/edit",
      params: params,
    });
  },
  // 删除
  delSensor: function (params) {
    return https.post({
      url: "/sensor/remove",
      params: params,
    });
  },
  //导出
  exportSensor: function (params) {
    return https.post({
      url: "/sensor/export",
      params: params,
      other: {
        responseType: "blob",
        contentType: "application/octet-stream;charset:utf-8",
      },
    });
  },
  // 获取水位计值
  getSensorValue: function (params) {
    return https.get({
      url: "/data/sensor",
      params,
    });
  },
  // 传感器部分信息
  selectSensorSub: function (params) {
    return https.post({
      url: "/base-data/api/sensor/data",
      params: params,
    });
  },

  /* 传感器状态统计 */
  // 列表
  getSensorOnlineRateList: function (params) {
    return https.get({
      url: "/cron/rate",
      params: params,
    });
  },
  /*工单管理*/
  getRepair(params) {
    return https.get({
      url: "/repair/list",
      params,
    });
  },

  // 管理工单的设备详情
  getDeviceDetail(params) {
    return https.get({
      url: `/mobile/device/${params.id}`,
    });
  },

  // 获取运维人员
  getOperator(params) {
    return https.get({
      url: "/user/options",
      params,
    });
  },

  // 创建工单
  createOrder(params) {
    return https.post({
      url: "/repair/create",
      params,
    });
  },

  // 工单详情
  getRepairDetail(params) {
    return https.get({
      url: `/repair/${params.id}`,
    });
  },

  // 审批历史
  getRepairHistory(params) {
    return https.get({
      url: `/repair/history/${params.id}`,
    });
  },

  // 修改工单
  updateOrder(params) {
    return https.post({
      url: "/repair/update",
      params,
    });
  },

  // 通过工单
  confirm(params) {
    return https.post({
      url: "/repair/confirm",
      params,
    });
  },

  // 开始施工
  startRepair(params) {
    return https.post({
      url: "/repair/accept",
      params,
    });
  },

  // 运维施工暂存或提交(图片和信息)
  repairTemporaryStorage(params) {
    return https.post({ url: "/repair/attachment/create", params });
  },

  // 运维施工完成提交审核(信息)  （不符合逻辑接口）
  repairSubmit(params) {
    return https.post({ url: "/repair/submit", params });
  },

  // 更新施工信息
  repairUpdateSubmit(params) {
    return https.post({
      url: "/repair/resubmit",
      params,
    });
  },

  // 结束工单
  finishOrder(params) {
    return https.post({
      url: "/repair/finished",
      params,
    });
  },
  // 技术负责人审批通过
  endOrder(params) {
    return https.post({ url: "/repair/end", params });
  },
  // 技术负责人审批不通过
  rollback(params) {
    return https.post({ url: "/repair/rollback", params });
  },

  // 技术负责人驳回
  turnDown(params) {
    return https.post({ url: "/repair/back", params });
  },

  // 删除工单
  deleteOrder(params) {
    return https.post({
      url: "/repair/remove",
      params,
    });
  },

  // 添加固件
  addOta(params) {
    return https.post({
      url: "/upgrade/upload",
      params,
      contentType: "multipart/form-data;",
    });
  },

  // 获取固件列表
  getOtaList(params) {
    return https.get({
      url: "/upgrade/list",
      params,
    });
  },

  // 删除固件
  deleteOta(params) {
    return https.post({
      url: "/upgrade/remove",
      params,
    });
  },

  // 选择固件升级
  updateOta(params) {
    return https.post({
      url: "/device/upgrade",
      params,
    });
  },

  // 升级进度
  upgradeProcess(params) {
    return https.get({
      url: "/upgrade/process",
      params,
      loading: false,
    });
  },
  /*-----------------------------------数据管理-------------------------*/
  /**原始数据查询*/
  // 列表
  getOriginalReportList: function (params) {
    return https.get({
      url: "/data/original",
      params: params,
    });
  },
  //导出
  exportOriginalReport: function (params) {
    return https.post({
      url: "/data/original/export",
      params: params,
      other: {
        responseType: "blob",
        contentType: "application/octet-stream;charset:utf-8",
      },
    });
  },

  exportParseReport: function (params) {
    return https.post({
      url: "/data/parse/export",
      params: params,
      other: {
        responseType: "blob",
        contentType: "application/octet-stream;charset:utf-8",
      },
    });
  },
    /*-----------------------------------报警处置-------------------------*/
  getAlarmList(params) {
    return https.get({
      url: "/alarm/list",
      params,
    });
  },

  editAlarm(params) {
    return https.post({
      url: "/alarm/edit",
      params,
    });
  },


  /*************************************系统管理******************************* */

  /**用户管理 */
  // 列表
  getUserManageList: function (params) {
    return https.get({
      url: "/user/list",
      params: params,
    });
  },
  // 详情
  getUserManageInfo: function (params) {
    return https.get({
      url: `/user/${params.id}`,
    });
  },
  // 新增
  addUserManage: function (params) {
    return https.post({
      url: "/user/create",
      params: params,
    });
  },
  // 修改
  updateUserManage: function (params) {
    return https.post({
      url: "/user/edit",
      params: params,
    });
  },
  // 删除
  delUserManage: function (params) {
    return https.post({
      url: "/user/remove",
      params: params,
    });
  },

  // 修改密码
  userManageUpdatePassword: function (params) {
    return https.post({
      url: "/base/api/sys/user/updatePassword",
      params: params,
    });
  },

  // 所属公司
  getCompany: function (params) {
    return https.get({
      url: "/company/options",
      params: params,
    });
  },

  /* 角色管理 */
  // 角色列表
  getRoleManageList: function (params) {
    return https.get({
      url: "/role/list",
      params: params,
    });
  },

  // 角色下拉列表
  getRoleNames() {
    return https.get({
      url: "/role/options",
    });
  },

  /* 公司管理 */
  // 列表
  getCompanyList: function (params) {
    return https.get({
      url: "/company/list",
      params: params,
    });
  },

  // 新增
  createCompany: function (params) {
    return https.post({
      url: "/company/create",
      params: params,
    });
  },
  // 删除
  delOrganManage: function (params) {
    return https.post({
      url: "/company/remove",
      params: params,
    });
  },
  // 修改
  updateCompany: function (params) {
    return https.post({
      url: "/company/edit",
      params: params,
    });
  },

  // 详情
  getCompanyDetail: function (params) {
    return https.get({
      url: `/company/${params.id}`,
    });
  },

  /*角色管理*/
  // 树形规则
  getRules: function () {
    return https.get({
      url: "/rule/tree",
    });
  },
  // 新增
  addRoleManage: function (params) {
    return https.post({
      url: "/role/create",
      params: params,
    });
  },
  // 删除
  delRoleManage: function (params) {
    return https.post({
      url: "/role/remove",
      params: params,
    });
  },
  // 修改
  updateRoleManage: function (params) {
    return https.post({
      url: "/role/edit",
      params: params,
    });
  },

  // 详情
  getRoleManageInfo: function (params) {
    return https.get({
      url: `/role/${params.id}`,
    });
  },

  /*----------------------------------公共组件--------------------------- */

  /*数据服务组件 */
  // 列表
  getDataServiceList: function (params) {
    return https.post({
      url: "/quartz/api/jobs/list",
      params: params,
    });
  },
  // 详情
  getDataServiceInfo: function (params) {
    return https.get({
      url: "/quartz/api/jobs/info",
      params: params,
    });
  },
  // 新增
  addDataService: function (params) {
    return https.post({
      url: "/quartz/api/jobs/save",
      params: params,
    });
  },
  // 删除
  delDataService: function (params) {
    return https.post({
      url: "/quartz/api/jobs/delete",
      params: params,
    });
  },
  // 修改
  updateDataService: function (params) {
    return https.post({
      url: "/quartz/api/jobs/update",
      params: params,
    });
  },
  // 执行任务
  runDataService: function (params) {
    return https.post({
      url: "/quartz/api/jobs/resume",
      params: params,
    });
  },
  // 暂停任务
  pauseDataService: function (params) {
    return https.post({
      url: "/quartz/api/jobs/pause",
      params: params,
    });
  },

  // 任务执行日志list
  getLogsService: function (params) {
    return https.post({
      url: "/quartz/api/jobs/logs",
      params: params,
    });
  },

  /* 应用系统清单 */

  /*-----------------------------系统管理---------------------------- */

  // 查询地图服务
  getUserMapService: function (params) {
    return https.get({
      url: "/base/api/sys/user/map/service/userMapService",
      params: params,
    });
  },
  // 设置用户地图服务权限
  setUserMapService: function (params) {
    return https.post({
      url: "/base/api/sys/user/map/service/setUserMapService",
      params: params,
    });
  },

  // 启用/禁用
  changeStatusRoleManage: function (params) {
    return https.post({
      url: "/base/api/sys/role/changeStatus",
      params: params,
    });
  },

  // 查询当前角色绑定菜单树
  getRoleMenuTree: function (params) {
    return https.get({
      url: "/base/api/sys/role/menu/roleMenuTree",
      params: params,
    });
  },
  // 设置角色菜单权限
  setRoleMenu: function (params) {
    return https.post({
      url: "/base/api/sys/role/menu/setRoleMenu",
      params: params,
    });
  },

  /* 菜单管理 */
  // 列表
  getMenuManageList: function (params) {
    return https.post({
      url: "/base/api/sys/menu/listTree",
      params: params,
    });
  },
  // 获取菜单树
  getMenuTree: function () {
    return https.get({ url: "/base/api/sys/menu/menuTree" });
  },
  // 详情
  getMenuManageInfo: function (params) {
    return https.get({
      url: "/base/api/sys/menu/info",
      params: params,
    });
  },
  // 新增
  addMenuManage: function (params) {
    return https.post({
      url: "/base/api/sys/menu/add",
      params: params,
    });
  },
  // 删除
  delMenuManage: function (params) {
    return https.post({
      url: "/base/api/sys/menu/del",
      params: params,
    });
  },
  // 修改
  updateMenuManage: function (params) {
    return https.post({
      url: "/base/api/sys/menu/update",
      params: params,
    });
  },
  // 启用/禁用
  changeStatusMenuManage: function (params) {
    return https.post({
      url: "/base/api/sys/menu/changeStatus",
      params: params,
    });
  },

  /* 操作日志 */
  // 列表
  getOplogManageList: function (params) {
    return https.post({
      url: "/log/operateLog/queryList",
      params: params,
    });
  },

  /* 系统日志 */
  // 列表
  getSyslogManageList: function (params) {
    return https.post({
      url: "/log/errorLog/queryList",
      params: params,
    });
  },

  /* ------------------------------站网报警处置--------------------------------------*/
  // 列表
  getAlarmRecordList: function (params) {
    return https.post({
      url: "/base-data/api/alarm/record/list",
      params: params,
    });
  },
  // 详情
  getAlarmRecordInfo: function (params) {
    return https.get({
      url: "/base-data/api/alarm/record/info",
      params: params,
    });
  },
  // 新增
  addAlarmRecord: function (params) {
    return https.post({
      url: "/base-data/api/alarm/record/add",
      params: params,
    });
  },
  // 修改
  updateAlarmRecord: function (params) {
    return https.post({
      url: "/base-data/api/alarm/record/update",
      params: params,
    });
  },
  // 删除
  delAlarmRecord: function (params) {
    return https.post({
      url: "/base-data/api/alarm/record/del",
      params: params,
    });
  },
  /* 报警处置 - 原始数据查询 */
  // 列表
  getAlarmRecordList: function (params) {
    return https.post({
      url: "/base-data/api/alarm/record/list",
      params: params,
    });
  },

  /* 设备维护管理 */
  // 列表
  getDeviceMaintenanceList: function (params) {
    return https.post({
      url: "/base-data/api/device/maintenance/list",
      params: params,
    });
  },
  // 列表 一张图
  getDeviceMaintenanceListPage: function (params) {
    return https.post({
      url: "/base-data/api/device/maintenance/list/page",
      params: params,
    });
  },
  // 新增
  addDeviceMaintenance: function (params) {
    return https.post({
      url: "/base-data/api/device/maintenance/add",
      params: params,
    });
  },
  // 修改
  updateDeviceMaintenance: function (params) {
    return https.post({
      url: "/base-data/api/device/maintenance/update",
      params: params,
    });
  },
  // 详情
  getDeviceMaintenanceInfo: function (params) {
    return https.get({
      url: "/base-data/api/device/maintenance/info",
      params: params,
    });
  },
  //查询维护记录
  getDeviceMaintenanceRecord: function (params) {
    return https.get({
      url: "/base-data/api/device/maintenance/record",
      params: params,
    });
  },
  // 删除
  delDeviceMaintenance: function (params) {
    return https.post({
      url: "/base-data/api/device/maintenance/del",
      params: params,
    });
  },

  /* 设备维修管理 */
  getDeviceRepairList: function (params) {
    return https.post({
      url: "/base-data/api/device/repair/list",
      params: params,
    });
  },
  // 一张图
  getDeviceRepairListPage: function (params) {
    return https.post({
      url: "/base-data/api/device/repair/list/page",
      params: params,
    });
  },
  // 新增
  addDeviceRepair: function (params) {
    return https.post({
      url: "/base-data/api/device/repair/add",
      params: params,
    });
  },
  // 修改
  updateDeviceRepair: function (params) {
    return https.post({
      url: "/base-data/api/device/repair/update",
      params: params,
    });
  },
  // 详情
  getDeviceRepairInfo: function (params) {
    return https.get({
      url: "/base-data/api/device/repair/info",
      params: params,
    });
  },
  //维修记录查询
  getDeviceRepairRecord: function (params) {
    return https.get({
      url: "/base-data/api/device/repair/record",
      params: params,
    });
  },
  // 删除
  delDeviceRepair: function (params) {
    return https.post({
      url: "/base-data/api/device/repair/del",
      params: params,
    });
  },
  /**文件操作 */

  // 根据业务编码查询附件
  selectAttach: function (params) {
    return https.get({
      url: "/base/api/attach/manage/info",
      params: params,
    });
  },
  // 附件关联业务数据
  saveAttach: function (params) {
    return https.post({
      url: "/base/api/attach/manage/add/batch",
      params: params,
      contentType: "multipart/form-data;",
    });
  },

  /**------------------------------------废弃-------------------------------------- */

  /* 应用系统清单 */
  // 列表
  getAppList: function (params) {
    return https.post({
      url: "/auto/api/app/list",
      params: params,
    });
  },
  // 详情
  getAppInfo: function (params) {
    return https.get({
      url: "/auto/api/app/info",
      params: params,
    });
  },
  // 新增
  addApp: function (params) {
    return https.post({
      url: "/auto/api/app/add",
      params: params,
    });
  },
  // 删除
  delApp: function (params) {
    return https.post({
      url: "/auto/api/app/del",
      params: params,
    });
  },
  // 修改
  updateApp: function (params) {
    return https.post({
      url: "/auto/api/app/update",
      params: params,
    });
  },
  // 启用/禁用
  changeStatusApp: function (params) {
    return https.post({
      url: "/auto/api/app/changeStatus",
      params: params,
    });
  },

  // 根据应用appGuid查询地图服务
  getAppMapService: function (params) {
    return https.get({
      url: "/auto/api/app/map/service/appMapService",
      params: params,
    });
  },
  // 设置应用地图服务权限
  setAppMapService: function (params) {
    return https.post({
      url: "/auto/api/app/map/service/setAppMapService",
      params: params,
    });
  },

  // 生成app_tk
  generateAppToken: function (params) {
    return https.get({
      url: "/auto/api/app/generateAppToken",
      params: params,
    });
  },

  // 生成密钥
  generateSecretKey: function () {
    return https.get({
      url: "/auto/api/app/generateSecretKey",
    });
  },

  // 设置应用地图服务权限
  setSecretKey: function (params) {
    return https.post({
      url: "/auto/api/app/setSecretKey",
      params: params,
    });
  },

  /*-----------------------------下行指令接口 ---------------------------------------*/
  // //下发指令-查询实时数据
  // rtdataDownReport: function (params) {
  //   return https.post({
  //     url: "/base-data/api/device/rtdata",
  //     params: params,
  //   });
  // },
  // //下发指令-远程配置
  // configDownReport: function (params) {
  //   return https.post({
  //     url: "/base-data/api/device/config",
  //     params: params,
  //   });
  // },
  // //下发指令-远程校时
  // clockDownReport: function (params) {
  //   return https.post({
  //     url: "/base-data/api/device/clock",
  //     params: params,
  //   });
  // },
  // //下发指令-远程开锁
  // lockDownReport: function (params) {
  //   return https.post({
  //     url: "/base-data/api/device/lock",
  //     params: params,
  //   });
  // },

  /*-------------------------------------报文分析--------------------------------*/
  /**监测数据管理*/
  // 列表
  getParseList: function (params) {
    return https.get({
      url: "/data/parse",
      params: params,
    });
  },

  getRainList: function (params) {
    return https.get({
      url: "/data/rain/parse",
      params: params,
    });
  },
  getTiltList: function (params) {
    return https.get({
      url: "/data/tilt/parse",
      params: params,
    });
  },

  // 裂缝
  getCrackList: function (params) {
    return https.get({
      url: "/data/crack/parse",
      params: params,
    });
  },

  /**位移数据 */
  getReplaceList: function (params) {
    return https.get({
      url: "/data/displace/parse",
      params,
    });
  },
  /**gnss数据 */
  getGnssList: function (params) {
    return https.get({
      url: "/data/gnss/parse",
      params,
    });
  },
  // 土壤含水率
  getSoilList: function (params) {
    return https.get({
      url: "/data/soil/parse",
      params,
    });
  },

  // 趋势图
    getTrend: function (params) {
    return https.post({
      url: "/data/trend",
      params,
    });
  },

















  // 获取孔隙水压力计监测数据
  getKxsMonitorList: function (params) {
    return https.post({
      url: "/monitor/api/data/kxs/data",
      params: params,
    });
  },
  // 获取孔隙水压力计监测数据(列表)
  getKxsMonitorList: function (params) {
    return https.post({
      url: "/monitor/api/data/kxs/list",
      params: params,
    });
  },
  // 获取静力水准仪压力计监测数据(列表)
  getJlszyMonitorList: function (params) {
    return https.post({
      url: "/monitor/api/data/jlszy/list",
      params: params,
    });
  },
  // 获取水位计压力计监测数据(列表)
  getSwjMonitorList: function (params) {
    return https.post({
      url: "/monitor/api/data/swj/list",
      params: params,
    });
  },
  // 获取孔隙水压力计监测数据(图表)
  getKxsMonitorData: function (params) {
    return https.post({
      url: "/monitor/api/data/kxs/data",
      params: params,
    });
  },
  // 获取静力水准仪压力计监测数据(图表)
  getJlszyMonitorData: function (params) {
    return https.post({
      url: "/monitor/api/data/jlszy/data",
      params: params,
    });
  },
  // 获取水位计压力计监测数据(图表)
  getSwjMonitorData: function (params) {
    return https.post({
      url: "/monitor/api/data/swj/data",
      params: params,
    });
  },

  // 获取天气
  getTodayWeather: function (params) {
    return https.get({ url: "/area/weather", params });
  },

  //生成APIkey
  generateSecretKey: function (params) {
    return https.get({
      url: "/base-data/api/device/generateSecretKey",
      params: params,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js